import React from "react";
import { useTheme } from "styled-components";
import Svg from "../Svg";

const Icon = (props) => {
  const theme = useTheme();
  const { size } = props;
  return (
    <Svg
      width={size ?? 14}
      height={size ?? 14}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M1.66634 3.00013H0.333008V12.3335C0.333008 13.0668 0.933008 13.6668 1.66634 13.6668H10.9997V12.3335H1.66634V3.00013ZM12.333 0.333466H4.33301C3.59967 0.333466 2.99967 0.933466 2.99967 1.6668V9.6668C2.99967 10.4001 3.59967 11.0001 4.33301 11.0001H12.333C13.0663 11.0001 13.6663 10.4001 13.6663 9.6668V1.6668C13.6663 0.933466 13.0663 0.333466 12.333 0.333466ZM12.333 9.6668H4.33301V1.6668H12.333V9.6668ZM8.00634 5.77347C8.27968 5.2868 8.79301 5.00013 9.09301 4.57347C9.41301 4.12013 9.23301 3.28013 8.33301 3.28013C7.74634 3.28013 7.45301 3.7268 7.33301 4.10013L6.41967 3.72013C6.67301 2.97347 7.34634 2.33347 8.32634 2.33347C9.14634 2.33347 9.71301 2.7068 9.99967 3.17347C10.2463 3.57347 10.3863 4.3268 10.0063 4.8868C9.58634 5.5068 9.18634 5.69347 8.96634 6.09347C8.87967 6.25347 8.84634 6.36013 8.84634 6.88013H7.83301C7.83967 6.6068 7.79301 6.16013 8.00634 5.77347ZM7.63301 8.30013C7.63301 7.9068 7.94634 7.6068 8.33301 7.6068C8.72634 7.6068 9.02634 7.9068 9.02634 8.30013C9.02634 8.6868 8.73301 9.00013 8.33301 9.00013C7.94634 9.00013 7.63301 8.6868 7.63301 8.30013Z"
        fill={theme.colors.foregroundHighEmphasis}
      />
    </Svg>
  );
};

export default Icon;
